const DEFAULT_MONEY_MIN = 0;
const DEFAULT_MONEY_MAX = 9_999_999.9999;

export interface ValidateMoneyOpts {
  required?: boolean;
  allowNegative?: boolean;
  min?: number;
  max?: number;
  fieldLabel?: string;
}

export function validateMoney(
  value: number | null,
  opts: ValidateMoneyOpts = {}
): string {
  const {
    required = false,
    allowNegative = false,
    min = allowNegative ? -DEFAULT_MONEY_MAX : DEFAULT_MONEY_MIN,
    max = DEFAULT_MONEY_MAX,
    fieldLabel = 'This field',
  } = opts;

  if (value === null) {
    if (required) return `${fieldLabel} is required`;
    return '';
  }

  if (value < min || value > max) {
    if (allowNegative) {
      return 'Enter a number between -10 Million and 10 Million';
    }
    return 'Enter a number between 0 and 10 Million';
  }

  return '';
}

export interface ValidatePercentOpts {
  required?: boolean;
  allowZero?: boolean;
  fieldLabel?: string;
}

export function validatePercent(
  value: number | null,
  opts: ValidatePercentOpts = {}
): string {
  const {
    required = false,
    allowZero = false,
    fieldLabel = 'This field',
  } = opts;

  if (value === null) {
    if (required) return `${fieldLabel} is required`;
    return '';
  }

  if (value < -100 || value > 100) {
    return `${fieldLabel} must be within the range of -100 to 100, and not a zero`;
  }

  if (!allowZero && value === 0) {
    return `${fieldLabel} must be within the range of -100 to 100, and not a zero`;
  }

  return '';
}